
export { BoldText } from "/home/runner/work/capsicum/capsicum/libs/common-web/ui/index.ts"
export { Button } from "/home/runner/work/capsicum/capsicum/libs/common-web/ui/index.ts"
export { Image } from "/home/runner/work/capsicum/capsicum/libs/common-web/ui/index.ts"